import { render, staticRenderFns } from "./CarBrandList.vue?vue&type=template&id=0aa5a27e&scoped=true&"
import script from "./CarBrandList.vue?vue&type=script&lang=js&"
export * from "./CarBrandList.vue?vue&type=script&lang=js&"
import style0 from "./CarBrandList.vue?vue&type=style&index=0&id=0aa5a27e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa5a27e",
  null
  
)

export default component.exports